import { useTranslation } from 'react-i18next';
import icon_consulting_search from '../../assets/banner/home/icon_consulting_search.svg';
import icon_consulting_home from '../../assets/banner/home/icon_consulting_home.svg';
import icon_consulting_result from '../../assets/banner/home/icon_consulting_result.svg';
import CUnderline from '../../components/CUnderline';
import background_consulting_right from '../../assets/banner/home/background_consulting_right.png';
import background_consulting_right_mobile from '../../assets/banner/home/background_consulting_right_mobile.png';
import useIsMobile from '../../hooks/useIsMobile';

const SectionHeroConsultingFeatures = () => {
    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile()
    return (
        <>
            <section className='consulting-features'>
                <div className='features-container'>
                    <div className='features-list'>
                        <div className='m-b-1-rem m-t-48-px-mobile'>
                            <h2 className='fs-25-mobile line-height-23-mobile'>{t('consulting.title')}</h2>
                            <CUnderline />
                            <p className='m-t-b-2-rem color-555555 fs-17 font-tomorrow' style={{lineHeight: '1.8'}}>
                                {t('consulting.description')}
                            </p>
                            <button className='btn-cta-link' onClick={() => window.location.href='/gioi-thieu'}>
                                {t('consulting.cta')} →
                            </button>
                        </div>
                    </div>
                    {/* <div className='feature-image'>
                        <img
                            className='w-100'
                            src={isMobile ? background_consulting_right_mobile : background_consulting_right}
                            alt={t('consulting.image_alt', 'Dashboard Preview')}
                        />
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default SectionHeroConsultingFeatures;